import React from "react";
import { StyledButton } from "components/atoms/ClearButton/ClearButton.styles";

export default function ClearButton(props) {
  return <StyledButton {...props}></StyledButton>;
}
